import { render, staticRenderFns } from "./SidebarRanking.vue?vue&type=template&id=deed371e&scoped=true"
import script from "./SidebarRanking.vue?vue&type=script&lang=js"
export * from "./SidebarRanking.vue?vue&type=script&lang=js"
import style0 from "./SidebarRanking.vue?vue&type=style&index=0&id=deed371e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deed371e",
  null
  
)

export default component.exports